import React, { useRef } from 'react';
import './select.scss';
import './index.scss';

import Cascader, { CascaderProps } from 'rc-cascader';
import clsx from 'clsx';
import ClearIcon from '@/assets/images/common/delete.svg';
import Image from 'next/image';

interface Validation {
  message: string;
}

type IProps = CascaderProps & {
  validation?: Validation;
  wrapCls?: string;
};

const CascaderComponent = React.forwardRef<HTMLInputElement, IProps>(function CascaderComponent(oters, ref) {
  const { validation, wrapCls, ...props } = oters;

  const cascaderRef = useRef<HTMLDivElement>();
  const cascaderCls = clsx({
    [props.className]: !!props.className,
    'c-cascader-validation--error': validation?.message,
  });

  const cascaderWrapCls = clsx({
    'flex flex-col': true,
    [wrapCls]: !!wrapCls,
  });

  return (
    <div className={cascaderWrapCls} ref={cascaderRef}>
      <Cascader
        prefixCls="c-cascader"
        {...props}
        className={cascaderCls}
        expandIcon={<i className="cascader-expand-icon" />}
        clearIcon={<Image src={ClearIcon} alt="" />}
        inputIcon={<i className="cascader-input-icon" />}
        dropdownMenuColumnStyle={{
          width: cascaderRef.current ? cascaderRef.current.clientWidth / 3 : 'auto',
          minWidth: 110,
        }}
      />

      {validation?.message && (
        <div className="c-input-validation c-input-validation--error">
          <span className="c-input__validation-icon"></span>
          <span className="c-input__validation-message">{validation?.message}</span>
        </div>
      )}
    </div>
  );
});

export { CascaderComponent };
